document.getElementById('calculate-btn').addEventListener('click', function() {
  // Get input values (all in millimeters)
  const surfaceLength = parseFloat(document.getElementById('surface-length').value);
  const surfaceWidth = parseFloat(document.getElementById('surface-width').value);
  const sheetLength = parseFloat(document.getElementById('sheet-length').value);
  const sheetWidth = parseFloat(document.getElementById('sheet-width').value);
  const pricePerSheet = parseFloat(document.getElementById('price-per-sheet').value);

  // Check if inputs are valid
  if (isNaN(surfaceLength) || isNaN(surfaceWidth) || isNaN(sheetLength) || isNaN(sheetWidth) || isNaN(pricePerSheet)) {
    alert('Please enter valid numbers.');
    return;
  }

  // Additional validation for positive values
  if (surfaceLength <= 0 || surfaceWidth <= 0 || sheetLength <= 0 || sheetWidth <= 0 || pricePerSheet <= 0) {
    alert('All values must be greater than 0.');
    return;
  }

  // Convert all values from mm to meters (1 meter = 1000 mm)
  const surfaceLengthM = surfaceLength / 1000;
  const surfaceWidthM = surfaceWidth / 1000;
  const sheetLengthM = sheetLength / 1000;
  const sheetWidthM = sheetWidth / 1000;

  // Calculate areas (in m²)
  const surfaceArea = surfaceLengthM * surfaceWidthM;  // Area in m²
  const sheetArea = sheetLengthM * sheetWidthM;        // Area in m²

  // Calculate the number of sheets required (rounded up)
  const sheetsRequired = Math.ceil(surfaceArea / sheetArea);

  // Calculate total price (number of sheets * price per sheet) and round it to 2 decimal places
  const totalPrice = sheetsRequired * pricePerSheet;
  const roundedTotalPrice = totalPrice.toFixed(2); // Round to 2 decimal places

  // Display Result 1: Number of Sheets
  document.getElementById('sheets-required').textContent = sheetsRequired;  // Show the total number of sheets required

  // Display Result 2: Total Price
  document.getElementById('total-price').textContent = roundedTotalPrice;  // Show the total price with 2 decimals

  // Show the results section
  document.getElementById('results').style.display = 'block';
});
